import moment from 'moment';
import template from './komentari.html';
import { NOVI, PROCITAN } from '../../models/komentar.js';

class KomentariController {
    constructor(DS, $q, $state, logger) {
        this.datastore = () => DS;
        this.$q = () => $q;
        this.$state = () => $state;
        this.logger = () => logger;
    }

    $onInit() {
        const DS = this.datastore();
        this.newComment = '';
        DS.find('RadniNalog', this.id, { bypassCache: true }).then(radniNalog => {
            this.item = radniNalog;
            this.refreshState();
        });
    }

    refreshState() {
        const DS = this.datastore();
        const Komentar = DS.definitions['Komentar'];
        const $q = this.$q();
        this.pageTitle = `Poruke radnog naloga: ${this.item.sifra_naloga}`;
        this.pageDesc = 'Evidencija zaprimljenih poruka operatera';
        $q.when(Komentar.findAll({ radni_nalog: this.item.id }, { bypassCache: true })).then(response => {
            this.komentari = [...response];
            response.filter(item => item.status === NOVI).map(item => {
                Komentar.update(item.id, { status: PROCITAN, radni_nalog: item.radni_nalog, poruka: item.poruka });
            });
        });
    }

    createComment(text) {
        const DS = this.datastore();
        const Komentar = DS.definitions['Komentar'];
        if (text.length > 0)
            Komentar.create({ radni_nalog: this.item.id, poruka: text }).then(komentar => {
                this.komentari = [komentar, ...this.komentari];
                this.newComment = '';
            });
    }

    getDayOfWeek(day) {
        return moment(day).format('dddd');
    }
}

KomentariController.$inject = ['DS', '$q', '$state', 'logger'];

const KomentariComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: KomentariController,
    controllerAs: 'vm',
    bindings: {
        id: '<'
    }
};

export { KomentariComponent };
export { KomentariController };



// WEBPACK FOOTER //
// ./app/components/radniNalog/komentari.component.js